import React from 'react';
import { GalleryModel } from '../../models/GalleryModel';
import { ModelBasePath } from '../../utils/ModelBasePath';

interface InlineGalleryState {
    currentIndex: number;
}

interface InlineGalleryProps {
    content: GalleryModel[]
}

class InlineGallery extends React.Component<InlineGalleryProps, InlineGalleryState> {
    freezeTimeout;
    maxItems:number = 5;
    touches:any = {
        startX: 0,
        endX: 0
    }
    
    constructor(props:InlineGalleryProps) {
        super(props);

        this.state = {
            currentIndex:0
        };

        this.gotoNext = this.gotoNext.bind(this);
        this.itemClass = this.itemClass.bind(this);
        this.handleTouchStart = this.handleTouchStart.bind(this);
        this.handleTouchEnd = this.handleTouchEnd.bind(this);
    }

    get galleryItems():GalleryModel[] {
        return this.props.content.slice(0, this.maxItems);
    }

    get prevIndex():number {
        const { currentIndex } = this.state;
        const { galleryItems } = this;
        return galleryItems[currentIndex-1] ? currentIndex-1 : galleryItems.length-1;
    }

    get beforePrevIndex():number {
        const { galleryItems } = this;
        return galleryItems[this.prevIndex-1] ? this.prevIndex-1 : galleryItems.length-1;
    }

    get nextIndex():number {
        const { currentIndex } = this.state;
        const { galleryItems } = this;
        return galleryItems[currentIndex+1] ? currentIndex+1 : 0;
    }

    get afterNextIndex():number {
        const { galleryItems } = this;
        return galleryItems[this.nextIndex+1] ? this.nextIndex+1 : 0;
    }

    gotoNext() {
        this.setState({currentIndex: this.nextIndex});
    }

    gotoPrev() {
        this.setState({currentIndex: this.prevIndex});
    }

    handleTouchStart(e) {
        this.touches.startX = e.changedTouches[0].screenX;
    }

    handleTouchEnd(e) {
        this.touches.endX = e.changedTouches[0].screenX;
        const difference = this.touches.endX - this.touches.startX;
        if(difference > 70) return this.gotoPrev();
        if(difference < -70) return this.gotoNext();
    }


    itemClass(index:number):string {
        let className = 'inlineGallery__item';

        if(index === this.state.currentIndex) return `${className} ${className}--current`;
        if(index === this.nextIndex) return `${className} ${className}--next`;
        if(index === this.prevIndex) return `${className} ${className}--prev`;
        if(index === this.afterNextIndex) return `${className} ${className}--after`;
        if(index === this.beforePrevIndex) return `${className} ${className}--before`;

        return className;
    }

    
    render() {
        const { galleryItems } = this;

        return (
            <section className="inlineGallery">
                <div className={`inlineGallery__items`} onTouchStart={this.handleTouchStart} onTouchEnd={this.handleTouchEnd}>
                    {
                        galleryItems.map((item:GalleryModel, index:number) => {
                            return (
                                <div key={index} className={this.itemClass(index)}>
                                    <div className="inlineGallery__image" style={{backgroundImage:`url("${item.thumbnail}")`}} />
                                </div>
                            )
                        })
                    }
                    <a href={`${ModelBasePath}gallery/all`} className="inlineGallery__expandLink">Full gallery</a>
                </div>
            </section>
        )
    }
}

export default InlineGallery;